import React from 'react';
import { ImageProps } from '@components/image';
import Section from '@components/section';
import Text from '@components/text';
import Wrapper from '@components/wrapper.styled';
import { RichTextBlock } from 'prismic-reactjs';
import { StyledImage, Content, Container } from './image-slice.styled';

export interface ImageSliceProps {
  image?: ImageProps;
  title?: string;
  description?: RichTextBlock[];
}

const ImageSlice = ({ image, description, title }: ImageSliceProps): JSX.Element => {
  if (!image) {
    return <></>;
  }

  const renderImage = (): JSX.Element => (
    <>
      {(image?.gatsbyImageData || image?.url) && (
        <StyledImage
          url={image.url}
          alt={image.alt || ''}
          gatsbyImageData={image.gatsbyImageData}
          objectFit="cover"
        />
      )}
    </>
  );

  return (
    <Section backgroundColor="white">
      <Wrapper>
        <Container>
          <Content>
            {title && (
              <Text
                tag="h2"
                type="title"
                stringText={title}
                fontSize="heading3"
                margin="none"
                fontColor="secondary"
              />
            )}
            {description && <Text type="subheading" richText={description} />}
          </Content>
          {image && renderImage()}
        </Container>
      </Wrapper>
    </Section>
  );
};

export default ImageSlice;
